(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
if(!customElements.get('xpai-search-results')){
 customElements.define('xpai-search-results',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();this.run();
  }
  disconnectedCallback(){this.abort.abort();}
  async run(){
   this.labels=JSON.parse(this.querySelector('[data-xr-labels]').textContent);
   this.grid=this.querySelector('.xr-grid');this.count=this.querySelector('.xr-count');
   this.dialog=this.querySelector('dialog');this.limit=Number(this.dataset.pageSize)||12;
   this.params=new URLSearchParams(location.search);this.category=this.params.get('xs_category')||'all';
   if(!['all','camera','bundle'].includes(this.category))this.category='all';
   this.querySelector('[name=xr_stock]').checked=this.params.get('xs_stock')==='1';
   this.querySelector('[name=xr_min]').value=this.params.get('xs_min')||'';
   this.querySelector('[name=xr_max]').value=this.params.get('xs_max')||'';
   const sort=this.querySelector('[name=xr_sort]');if(sort)sort.value=['price-ascending','price-descending','title-ascending'].includes(this.params.get('sort_by'))?this.params.get('sort_by'):'relevance';
   try{
    let data=JSON.parse(this.querySelector('[data-xr-catalog]').textContent);
    const fetchPage=async page=>{const url=new URL(location.href);url.search='';url.searchParams.set('section_id','xpai-search-catalog');url.searchParams.set('page',page);const res=await fetch(url,{signal:this.abort.signal});if(!res.ok)throw Error('catalog');const doc=new DOMParser().parseFromString(await res.text(),'text/html');return JSON.parse(doc.querySelector('[data-xr-catalog]').textContent);};
    if(Number(this.params.get('page'))>1)data=await fetchPage(1);
    this.products=data.products;let page=1;
    while(data.next){data=await fetchPage(++page);this.products.push(...data.products);}
    this.products=Array.from(new Map(this.products.map(p=>[String(p.id),p])).values());
    this.prepare();this.bind();this.render();
   }catch(e){if(e.name!=='AbortError'){this.count.textContent=this.labels.error;this.grid.setAttribute('aria-busy','false');}}
  }
  normalize(s){return String(s||'').toLowerCase().replace(/h50\s*pro\b/g,'h50p').replace(/[^\p{L}\p{N}]+/gu,' ').replace(/\bcameras\b/g,'camera').replace(/\bbundles\b/g,'bundle').trim();}
  prepare(){
   const maps=new Map(Array.from(document.querySelectorAll('[data-xs-map]')).map(e=>[e.dataset.xsMap,e.dataset]));
   for(const p of this.products){
    const m=maps.get(String(p.id))||{};if(!('sourceImage' in p))p.sourceImage=p.image;p.repeat=0;p.display=m.xsTitle||p.title;p.image=m.xsImage||p.sourceImage;
    const source=[p.title,p.handle,p.template,...p.tags].join(' ');const key=this.normalize(source);
    p.category=m.xsCategory&&m.xsCategory!=='auto'?m.xsCategory:source.includes('xpai-bundle')||source.includes('+')||source.includes('full-home-package')?'bundle':/\b[23456789][ -]?pack\b/i.test(source)?'multipack':'camera';
    p.packCount=p.category==='multipack'?Number(source.match(/\b([2-9])[ -]?pack\b/i)?.[1]||1):1;
    if(!p.image&&p.packCount>1){const model=key.split(' ').find(x=>['h80x','h50p','h30c'].includes(x));const base=Array.from(maps.values()).find(x=>this.normalize(x.xsTitle).split(' ').includes(model)&&x.xsImage);if(base){p.image=base.xsImage;p.repeat=p.packCount;}}
    p.preorder=['y3e','x3g'].includes(p.template);p.caption=m.xsCaption||(p.category==='bundle'?this.labels.bundle:p.category==='multipack'?this.labels.multipack:p.preorder?this.labels.outdoor:this.labels.camera);
    p.key=this.normalize(source+' '+p.display+' '+p.caption+' '+(m.xsKeywords||''));p.rank=p.category==='camera'?0:p.category==='multipack'?1:2;
   }
   const query=this.normalize(this.labels.terms);const words=query.split(' ').filter(Boolean);const models=words.filter(x=>['h80x','h50p','h30c','y3e','x3g'].includes(x));
   this.matches=this.products.filter(p=>models.length?models.every(x=>p.key.split(' ').includes(x))&&words.filter(w=>!models.includes(w)).every(w=>p.key.includes(w)):words.every(w=>p.key.includes(w)));
  }
  bind(){
   const signal=this.abort.signal;
   document.addEventListener('xpai:search-settings',()=>{this.prepare();this.render();},{signal});
   this.querySelectorAll('[data-xr-category]').forEach(b=>b.addEventListener('click',()=>{this.category=b.dataset.xrCategory;this.limit=Number(this.dataset.pageSize);this.updateURL();this.render();},{signal}));
   this.querySelector('[name=xr_sort]')?.addEventListener('change',()=>{this.limit=Number(this.dataset.pageSize);this.updateURL();this.render();},{signal});
   this.querySelector('.xr-more').addEventListener('click',()=>{this.limit+=Number(this.dataset.pageSize);this.render();},{signal});
   this.querySelector('.xr-filter-toggle')?.addEventListener('click',()=>this.dialog.showModal(),{signal});
   this.querySelector('[data-xr-close]').addEventListener('click',()=>this.dialog.close(),{signal});
   this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}},{signal});
   this.querySelector('[data-xr-apply]').addEventListener('click',()=>{this.limit=Number(this.dataset.pageSize);this.dialog.close();this.updateURL();this.render();},{signal});
   this.querySelector('[data-xr-clear]').addEventListener('click',()=>{this.querySelector('[name=xr_stock]').checked=false;this.querySelector('[name=xr_min]').value='';this.querySelector('[name=xr_max]').value='';this.limit=Number(this.dataset.pageSize);this.dialog.close();this.updateURL();this.render();},{signal});
  }
  updateURL(){
   const url=new URL(location.href);const set=(k,v)=>v?url.searchParams.set(k,v):url.searchParams.delete(k);
   set('xs_category',this.category==='all'?'':this.category);set('sort_by',this.querySelector('[name=xr_sort]')?.value==='relevance'?'':this.querySelector('[name=xr_sort]')?.value);set('xs_stock',this.querySelector('[name=xr_stock]').checked?'1':'');set('xs_min',this.querySelector('[name=xr_min]').value);set('xs_max',this.querySelector('[name=xr_max]').value);url.searchParams.delete('page');history.replaceState(null,'',url);
  }
  render(){
   const min=this.querySelector('[name=xr_min]').value;const max=this.querySelector('[name=xr_max]').value;const stock=this.querySelector('[name=xr_stock]').checked;
   let results=this.matches.filter(p=>(this.category==='all'||(this.category==='bundle'?p.category==='bundle':p.category!=='bundle'))&&(!stock||p.available)&&(!min||p.price>=Number(min)*100)&&(!max||p.price<=Number(max)*100));
   const sort=this.querySelector('[name=xr_sort]')?.value;
   results.sort((a,b)=>sort==='price-ascending'?a.price-b.price:sort==='price-descending'?b.price-a.price:sort==='title-ascending'?a.display.localeCompare(b.display):a.rank-b.rank||this.normalize(a.display).split(' ').length-this.normalize(b.display).split(' ').length||a.display.localeCompare(b.display));
   const el=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e;};const fragment=document.createDocumentFragment();
   results.slice(0,this.limit).forEach(p=>{
    const card=el('article','xr-card');const imageLink=el('a','xr-image');imageLink.href=p.url;imageLink.setAttribute('aria-label',p.display);
    if(p.image){const holder=p.repeat?el('span','xr-pack'):imageLink;if(p.repeat)imageLink.append(holder);for(let i=0;i<(p.repeat||1);i++){const img=el('img');img.src=p.image;img.alt=i===0?p.display:'';img.width=900;img.height=900;img.loading='lazy';holder.append(img);}}if(p.preorder)imageLink.append(el('span','xr-badge',this.labels.preorder));card.append(imageLink);
    const heading=el('h2','xr-card-title');const link=el('a',null,p.display);link.href=p.url;link.title=p.display;heading.append(link);card.append(heading,el('p','xr-caption',p.caption));
    const prices=el('p','xr-prices');prices.append(el('span',null,p.money));if(p.compare>p.price)prices.append(el('s',null,p.compareMoney));card.append(prices);const detail=el('a','xr-detail',this.labels.details);detail.href=p.url;const arrow=el('span',null,'→');arrow.setAttribute('aria-hidden','true');detail.append(arrow);card.append(detail);fragment.append(card);
   });
   this.grid.replaceChildren(fragment);this.grid.setAttribute('aria-busy','false');this.count.textContent=results.length===1?this.labels.countOne:this.labels.count.replace('__COUNT__',results.length);
   document.title=this.labels.title+' – '+this.count.textContent+' | XPAI';
   this.querySelector('.xr-empty').hidden=results.length>0;this.querySelector('.xr-more').hidden=results.length<=this.limit;
   this.querySelectorAll('[data-xr-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.xrCategory===this.category)));
   const filters=stock||min||max;this.querySelector('.xr-filter-toggle')?.toggleAttribute('data-active',Boolean(filters));
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
if(!customElements.get('xpai-search-settings')){
 customElements.define('xpai-search-settings',class extends HTMLElement{
  connectedCallback(){
   this.drawer=this.closest('search-drawer');
   this.abort=new AbortController();
   this.maps=new Map(Array.from(this.querySelectorAll('[data-xs-map]')).map(e=>[e.dataset.xsMap,{title:e.dataset.xsTitle,image:e.dataset.xsImage}]));
   const input=this.drawer.querySelector('input[name="q"]');
   const sync=()=>this.drawer.toggleAttribute('data-xs-has-query',Boolean(input.value.trim()));
   input.addEventListener('input',sync,{signal:this.abort.signal});
   this.drawer.querySelector('form').addEventListener('reset',()=>queueMicrotask(sync),{signal:this.abort.signal});
   this.drawer.addEventListener('click',e=>{
    const keyword=e.target.closest('[data-xs-query]');
    if(keyword){input.value=keyword.dataset.xsQuery;input.dispatchEvent(new Event('input',{bubbles:true}));input.focus();}
   },{signal:this.abort.signal});
   this.apply=()=>{
    document.querySelectorAll('[data-xs-product]').forEach(card=>{
     const map=this.maps.get(card.dataset.xsProduct);if(!map)return;
     const title=card.querySelector('[data-xs-result-title],.product-card__title a');
     if(title&&map.title&&title.textContent!==map.title){title.textContent=map.title;title.setAttribute('title',map.title);}
     let image=card.querySelector('img');
     if(!image&&map.image&&card.matches('product-card')){
      const productLink=card.querySelector('.product-card__title a');
      if(productLink){
       const figure=document.createElement('div');figure.className='product-card__figure';
       const link=document.createElement('a');link.href=productLink.getAttribute('href');
       image=document.createElement('img');image.className='product-card__image product-card__image--primary';
       image.style.cssText='width:100%;aspect-ratio:1;object-fit:contain';image.width=900;image.height=900;image.loading='lazy';
       link.append(image);figure.append(link);card.prepend(figure);
      }
     }
     if(image&&map.image&&image.getAttribute('src')!==map.image){image.setAttribute('src',map.image);image.removeAttribute('srcset');image.setAttribute('alt',map.title||image.alt);}
    });
   };
   this.observer=new MutationObserver(()=>this.apply());
   this.observer.observe(this.drawer.querySelector('predictive-search'),{childList:true,subtree:true});
   const main=document.querySelector('.shopify-section--main-search');
   if(main)this.observer.observe(main,{childList:true,subtree:true});
   this.apply();sync();document.dispatchEvent(new Event('xpai:search-settings'));
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x3g-preorder-y3e"] && !Shopify.designMode) return;
  try {
    
function initX3GHero(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const rail=root.querySelector('.x3g-shop__rail'),slides=[...root.querySelectorAll('.x3g-shop__slide')],thumbs=[...root.querySelectorAll('[data-gallery-index]')];
 function go(i){if(!slides.length)return;i=(i+slides.length)%slides.length;rail.scrollTo({left:i*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
 root.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>go(Math.round(rail.scrollLeft/rail.clientWidth)+Number(b.dataset.galleryStep))));
 thumbs.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.galleryIndex))));
 rail.addEventListener('scroll',()=>{const i=Math.round(rail.scrollLeft/rail.clientWidth);thumbs.forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));},{passive:true});
 root.querySelector('[data-show-rules]').addEventListener('click',()=>{const d=root.querySelector('details');d.open=true;d.querySelector('summary').focus();});
}
document.querySelectorAll('.x3g-shop').forEach(initX3GHero);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.x3g-shop').forEach(initX3GHero));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x3g-presale"] && !Shopify.designMode) return;
  try {
    
function initX3GPresale(root){if(root.dataset.x3gReady)return;root.dataset.x3gReady='1';const rail=root.querySelector('.x3g-presale__slides');const buttons=[...root.querySelectorAll('[data-x3g-image]')];buttons.forEach(button=>button.addEventListener('click',()=>rail.scrollTo({left:Number(button.dataset.x3gImage)*rail.clientWidth,behavior:'smooth'})));if(rail)rail.addEventListener('scroll',()=>{const index=Math.round(rail.scrollLeft/rail.clientWidth);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));},{passive:true})}document.querySelectorAll('.x3g-presale').forEach(initX3GPresale);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.x3g-presale').forEach(initX3GPresale));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x3g-story-y3e"] && !Shopify.designMode) return;
  try {
    
function initX3GStory(root){if(root.dataset.ready)return;root.dataset.ready='true';const range=root.querySelector('input[type=range]');if(range)range.addEventListener('input',()=>root.querySelector('.x3g-story__compare').style.setProperty('--position',range.value+'%'));}
document.querySelectorAll('.x3g-story').forEach(initX3GStory);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.x3g-story').forEach(initX3GStory));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-book-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xpai-book-video')){
customElements.define('xpai-book-video',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;
this.ready=true;
this.querySelector('.xpb-play')?.addEventListener('click',()=>this.start(false));
if(this.dataset.auto==='true'&&!window.Shopify?.designMode)this.start(true);
}
start(auto){
if(this.dataset.fixedPlayer==='true'){this.startFixed(auto);return;}
const template=this.querySelector('template');
if(!template||this.classList.contains('is-playing'))return;
const player=this.querySelector('.xpb-video-player');
player.replaceChildren(template.content.cloneNode(true));
const video=player.querySelector('video');
if(video){
if(auto)video.muted=true;
video.play().then(()=>this.classList.add('is-playing')).catch(()=>{player.replaceChildren();});
}else this.classList.add('is-playing');
}
startFixed(auto){
if(this.pending||this.classList.contains('is-playing'))return;
const template=this.querySelector('template'),player=this.querySelector('.xpb-video-player'),button=this.querySelector('.xpb-play'),error=this.querySelector('.xpb-video-error');
if(!template||!player)return;
this.pending=true;
if(button)button.disabled=true;
if(error)error.hidden=true;
this.setAttribute('aria-busy','true');
player.replaceChildren(template.content.cloneNode(true));
const video=player.querySelector('video'),frame=player.querySelector('iframe');
let timer,finished=false;
const settle=()=>{
this.pending=false;
this.setAttribute('aria-busy','false');
if(button)button.disabled=false;
clearTimeout(timer);
};
const fail=()=>{
if(finished)return;
finished=true;
settle();
video?.pause();
player.replaceChildren();
this.classList.remove('is-playing');
if(error)error.hidden=false;
};
const ready=()=>{
if(finished)return;
finished=true;
settle();
this.classList.add('is-playing');
if(video&&!auto){video.tabIndex=0;video.focus({preventScroll:true});}
};
timer=setTimeout(fail,20000);
if(video){
if(auto)video.muted=true;
video.addEventListener('error',()=>{
finished=false;fail();
},{once:true});
video.play().then(ready).catch(fail);
}else if(frame){
frame.addEventListener('load',ready,{once:true});
frame.addEventListener('error',fail,{once:true});
}else fail();
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-bundle-purchase"] && !Shopify.designMode) return;
  try {
    
function initXpaiBundlePurchases(){
 document.querySelectorAll('[data-bundle-purchase]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{const image=root.querySelector('img.xbp__hero');if(image){image.removeAttribute('srcset');image.src=button.dataset.image;}}));
  const form=root.querySelector('form');if(!form)return;
  form.addEventListener('submit',async event=>{
   event.preventDefault();if(root.dataset.busy)return;
   const quantity=Number(form.elements.quantity.value);if(!Number.isInteger(quantity)||quantity<1){form.reportValidity();return;}
   const action=event.submitter?.dataset.action||'cart';const error=root.querySelector('.xbp__error');error.hidden=true;
   root.dataset.busy='true';const buttons=[...form.querySelectorAll('button')];buttons.forEach(b=>b.disabled=true);
   try{const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||root.dataset.error);window.location.assign(action==='checkout'?root.dataset.cartUrl.replace(/cart\/?$/,'checkout'):root.dataset.cartUrl);}
   catch(e){error.textContent=e.message||root.dataset.error;error.hidden=false;delete root.dataset.busy;buttons.forEach(b=>b.disabled=false);}
  });
 });
}
initXpaiBundlePurchases();document.addEventListener('shopify:section:load',initXpaiBundlePurchases);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-common-questions"] && !Shopify.designMode) return;
  try {
    
(function() {
  function revealTarget() {
    var id = decodeURIComponent(window.location.hash.replace('#', ''));
    if (!id) return;
    var item = document.getElementById(id);
    if (!item) return;
    var toggle = item.querySelector('[data-faq-toggle]');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
    item.classList.remove('is-search-target');
    void item.offsetWidth;
    item.classList.add('is-search-target');
    window.setTimeout(function() {
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 120);
    window.setTimeout(function() {
      item.classList.remove('is-search-target');
    }, 3200);
  }
  document.querySelectorAll('[data-xpai-faq]').forEach(function(faq) {
    if (faq.dataset.ready === 'true') return;
    faq.dataset.ready = 'true';
    faq.querySelectorAll('[data-faq-toggle]').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var item = toggle.closest('[data-faq-item]');
        var answer = item.querySelector('.xpai-common__answer');
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        item.classList.toggle('is-open', !isOpen);
        if (answer) answer.setAttribute('aria-hidden', String(isOpen));
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealTarget);
  else revealTarget();
  window.addEventListener('hashchange', revealTarget);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-contact-us"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('xpai-contact-accordion')) {
  customElements.define('xpai-contact-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = this.querySelector('.xpai-contact-accordion__body');
      this.onClick = event => {
        event.preventDefault();
        const opening = this.animation ? !this.opening : !this.details.open;
        const from = this.details.getBoundingClientRect().height;
        if (this.animation) this.animation.cancel();
        this.opening = opening;
        this.details.open = true;
        this.body.inert = !opening;
        const to = opening ? this.summary.offsetHeight + this.body.offsetHeight : this.summary.offsetHeight;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.details.open = opening;
          this.animation = null;
          return;
        }
        this.animation = this.details.animate({height:[from+'px',to+'px']},{duration:250,easing:'ease-in-out'});
        if (opening) this.body.animate({opacity:[0,1]},{duration:250});
        this.animation.onfinish = () => {this.details.open = opening; this.animation = null;};
      };
      this.summary.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onClick);
      this.animation?.cancel();
      this.bound = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-help-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFaqSearch() {
    var searchBoxes = document.querySelectorAll('.xpai-help__search');
    Array.prototype.forEach.call(searchBoxes, function(search) {
      if (search.getAttribute('data-ready') === 'true') return;
      search.setAttribute('data-ready', 'true');
      var input = search.querySelector('input');
      var button = search.querySelector('button');
      var results = document.createElement('div');
      results.className = 'xpai-help__search-results';
      results.setAttribute('role', 'listbox');
      results.hidden = true;
      search.appendChild(results);

      var productFaqCatalog = [{"product":"H80X","question":"How many megapixels does the H80X-64G have?","answer":"The H80X-64G features an 8-megapixel camera, delivering greater clarity and more detail than the H30C's 3MP and the H50P's 5MP resolution.","url":"/pages/h80x-faq","target":"h80x-faq-q1","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support 5GHz Wi-Fi?","answer":"Yes. The H80X-64G supports dual-band 2.4GHz and 5GHz Wi-Fi, including Wi-Fi 6.","url":"/pages/h80x-faq","target":"h80x-faq-q2","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support Wi-Fi 6?","answer":"Yes. It supports dual-band Wi-Fi with Wi-Fi 6 compatibility and can be used with a Wi-Fi 6 router.","url":"/pages/h80x-faq","target":"h80x-faq-q3","aliases":"H80X H80X-64G"},{"product":"H80X","question":"How much storage does the H80X-64G support?","answer":"The H80X-64G includes built-in 64GB eMMC storage, so you can save recordings locally without purchasing a separate TF card.","url":"/pages/h80x-faq","target":"h80x-faq-q4","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Do I need to purchase a memory card for the H80X-64G?","answer":"No. The H80X-64G comes with built-in 64GB eMMC storage and does not require an additional TF card for local recording.","url":"/pages/h80x-faq","target":"h80x-faq-q5","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support an NVR?","answer":"Yes. The H80X-64G supports NVR systems for customers who need a more professional video storage solution.","url":"/pages/h80x-faq","target":"h80x-faq-q6","aliases":"H80X H80X-64G"},{"product":"H80X","question":"What AI detection features does the H80X-64G support?","answer":"The H80X-64G supports motion detection, human detection, pet detection, and unusual sound detection, offering more advanced AI detection than the basic models.","url":"/pages/h80x-faq","target":"h80x-faq-q7","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support human tracking?","answer":"Yes. When human activity is detected, the camera can automatically track the person to help you monitor movement.","url":"/pages/h80x-faq","target":"h80x-faq-q8","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support pet detection?","answer":"Yes. The H80X-64G supports pet detection, making it well suited for monitoring pets at home.","url":"/pages/h80x-faq","target":"h80x-faq-q9","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support unusual sound detection?","answer":"Yes. It can recognize unusual sounds and send alerts when potential abnormal activity is detected.","url":"/pages/h80x-faq","target":"h80x-faq-q10","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support two-way audio?","answer":"Yes. The camera supports two-way audio, allowing you to communicate in real time through the XPAI app.","url":"/pages/h80x-faq","target":"h80x-faq-q11","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support night vision?","answer":"Yes. It features infrared night vision, so you can continue viewing your camera feed in low-light and nighttime conditions.","url":"/pages/h80x-faq","target":"h80x-faq-q12","aliases":"H80X H80X-64G"},{"product":"H80X","question":"What privacy protection features does the H80X-64G offer?","answer":"The H80X-64G features a physical privacy shutter that covers the lens whenever monitoring is not needed, giving you greater control over your family's privacy.","url":"/pages/h80x-faq","target":"h80x-faq-q13","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support digital zoom?","answer":"Yes. It supports up to 16x digital zoom, making it easier to view details in the camera feed.","url":"/pages/h80x-faq","target":"h80x-faq-q14","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Can I view the H80X-64G remotely?","answer":"Yes. You can access the camera remotely and view the live feed through the XPAI app.","url":"/pages/h80x-faq","target":"h80x-faq-q15","aliases":"H80X H80X-64G"},{"product":"H80X","question":"Does the H80X-64G support custom alarm sounds?","answer":"Yes. You can set a custom alarm sound for the camera.","url":"/pages/h80x-faq","target":"h80x-faq-q16","aliases":"H80X H80X-64G"},{"product":"H80X","question":"What power connector does the H80X-64G use?","answer":"The H80X-64G uses a USB Type-C power connector and requires a 5V/2A power supply.","url":"/pages/h80x-faq","target":"h80x-faq-q17","aliases":"H80X H80X-64G"},{"product":"H50P","question":"Does the H50Pro support 5GHz Wi-Fi?","answer":"Yes. The H50Pro supports dual-band 2.4GHz and 5GHz Wi-Fi, giving you more flexible connection options than cameras that support 2.4GHz Wi-Fi only.","url":"/pages/h50p-faq","target":"h50p-faq-q1","aliases":"H50P H50Pro"},{"product":"H50P","question":"How many megapixels does the H50Pro have?","answer":"The H50Pro features a 5-megapixel camera, delivering clearer images and more detail than 3MP cameras.","url":"/pages/h50p-faq","target":"h50p-faq-q2","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support night vision?","answer":"Yes. The H50Pro features infrared night vision, allowing you to monitor your space clearly at night.","url":"/pages/h50p-faq","target":"h50p-faq-q3","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support human detection?","answer":"Yes. It supports both human detection and human tracking, helping reduce unnecessary alerts caused by general motion detection.","url":"/pages/h50p-faq","target":"h50p-faq-q4","aliases":"H50P H50Pro"},{"product":"H50P","question":"Can the H50Pro automatically track people?","answer":"Yes. When human activity is detected, the H50Pro can automatically track the subject to help you keep an eye on their movements.","url":"/pages/h50p-faq","target":"h50p-faq-q5","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support two-way audio?","answer":"Yes. You can use the XPAI app for two-way talk and communicate in real time with anyone near the camera.","url":"/pages/h50p-faq","target":"h50p-faq-q6","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support a TF card?","answer":"Yes. The H50Pro supports TF card storage, including 32GB and 64GB cards, with support for memory cards up to 512GB.","url":"/pages/h50p-faq","target":"h50p-faq-q7","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support NVR systems?","answer":"No. The H50Pro does not support NVR systems.","url":"/pages/h50p-faq","target":"h50p-faq-q8","aliases":"H50P H50Pro"},{"product":"H50P","question":"Can I view the H50Pro remotely?","answer":"Yes. You can access the camera remotely and view the live feed through the XPAI app.","url":"/pages/h50p-faq","target":"h50p-faq-q9","aliases":"H50P H50Pro"},{"product":"H50P","question":"Does the H50Pro support custom alarm sounds?","answer":"Yes. You can set a custom alarm sound to match your preferences and monitoring needs.","url":"/pages/h50p-faq","target":"h50p-faq-q10","aliases":"H50P H50Pro"},{"product":"H50P","question":"What installation options does the H50Pro support?","answer":"The H50Pro supports both ceiling mounting and wall mounting, so you can choose the best installation position for your home.","url":"/pages/h50p-faq","target":"h50p-faq-q11","aliases":"H50P H50Pro"},{"product":"H30C","question":"What type of Wi-Fi does the H30C support?","answer":"The H30C supports 2.4GHz Wi-Fi only. It does not support 5GHz Wi-Fi.","url":"/pages/h30c-faq","target":"h30c-faq-q1","aliases":"H30C"},{"product":"H30C","question":"How many megapixels does the H30C have, and how is the image quality?","answer":"The H30C features a 3-megapixel camera that delivers clear everyday monitoring. It is well suited for indoor home security, pet monitoring, senior care, and baby monitoring.","url":"/pages/h30c-faq","target":"h30c-faq-q2","aliases":"H30C"},{"product":"H30C","question":"Does the H30C support night vision?","answer":"Yes. The H30C uses infrared night vision, allowing you to view your camera feed at night.","url":"/pages/h30c-faq","target":"h30c-faq-q3","aliases":"H30C"},{"product":"H30C","question":"Is the H30C's night vision in color?","answer":"The H30C primarily uses infrared night vision, so nighttime footage is displayed in black and white. It does not support color night vision.","url":"/pages/h30c-faq","target":"h30c-faq-q4","aliases":"H30C"},{"product":"H30C","question":"Does the H30C support motion detection?","answer":"Yes. The H30C supports motion detection and human detection, helping you focus more accurately on people in the monitored area.","url":"/pages/h30c-faq","target":"h30c-faq-q5","aliases":"H30C"},{"product":"H30C","question":"Can the H30C automatically track people?","answer":"No. The H30C does not support automatic human tracking.","url":"/pages/h30c-faq","target":"h30c-faq-q6","aliases":"H30C"},{"product":"H30C","question":"Does the H30C support two-way audio?","answer":"Yes. You can use the XPAI app to talk in real time with anyone near the camera.","url":"/pages/h30c-faq","target":"h30c-faq-q7","aliases":"H30C"},{"product":"H30C","question":"What size memory card does the H30C support?","answer":"The H30C supports TF card storage up to 512GB. It is compatible with 32GB and 64GB TF card configurations.","url":"/pages/h30c-faq","target":"h30c-faq-q8","aliases":"H30C"},{"product":"H30C","question":"Does the H30C support NVR recording?","answer":"No. The H30C does not support NVR recording.","url":"/pages/h30c-faq","target":"h30c-faq-q9","aliases":"H30C"},{"product":"H30C","question":"Can I view the H30C remotely?","answer":"Yes. You can monitor the H30C remotely through the XPAI app, even when you are away from home.","url":"/pages/h30c-faq","target":"h30c-faq-q10","aliases":"H30C"},{"product":"H30C","question":"Does the H30C support custom alarm sounds?","answer":"Yes. You can set a custom alarm sound based on your preferences and monitoring needs.","url":"/pages/h30c-faq","target":"h30c-faq-q11","aliases":"H30C"},{"product":"H30C","question":"What is the H30C best suited for?","answer":"The H30C is well suited for indoor home monitoring, baby monitoring, pet monitoring, and senior care.","url":"/pages/h30c-faq","target":"h30c-faq-q12","aliases":"H30C"},{"product":"H30C","question":"How do I install the H30C?","answer":"The H30C supports flexible adhesive mounting, allowing you to choose a suitable installation location based on your space and needs.","url":"/pages/h30c-faq","target":"h30c-faq-q13","aliases":"H30C"},{"product":"H30C","question":"What power connector does the H30C use?","answer":"The H30C uses a USB Type-C power connector and requires a 5V/1A power supply.","url":"/pages/h30c-faq","target":"h30c-faq-q14","aliases":"H30C"}];
      function normalize(value) {
        return (value || '').toLowerCase().replace(/[–—-]/g, ' ').replace(/[^a-z0-9]+/g, ' ').replace(/s+/g, ' ').trim();
      }
      function currentPageItems() {
        return Array.prototype.slice.call(document.querySelectorAll('[data-faq-item], .xpai-faq__questions details')).map(function(item) {
          var question = item.querySelector('.xpai-common__question') || item.querySelector('summary');
          return {
            question: question ? question.textContent.replace('+', '').trim() : '',
            answer: item.textContent || '',
            product: '',
            aliases: '',
            url: window.location.pathname + window.location.search,
            target: item.id
          };
        });
      }
      function indexedItems() {
        return Array.prototype.slice.call(document.querySelectorAll('[data-search-faq]')).map(function(node) {
          return {
            question: node.getAttribute('data-question') || '',
            answer: node.getAttribute('data-answer') || '',
            product: node.getAttribute('data-product') || '',
            aliases: node.getAttribute('data-aliases') || '',
            url: node.getAttribute('data-url') || '',
            target: node.getAttribute('data-target') || ''
          };
        });
      }
      function score(item, query, tokens) {
        var question = normalize(item.question);
        var answer = normalize(item.answer);
        var product = normalize(item.product + ' ' + item.aliases);
        var combined = question + ' ' + answer + ' ' + product;
        if (!tokens.every(function(token) { return combined.indexOf(token) !== -1; })) return 0;
        var value = 1;
        if (question === query) value += 100;
        if (question.indexOf(query) !== -1) value += 50;
        tokens.forEach(function(token) {
          if (question.indexOf(token) !== -1) value += 12;
          else if (answer.indexOf(token) !== -1) value += 5;
          else if (product.indexOf(token) !== -1) value += 3;
        });
        return value;
      }
      function balanced(matches) {
        var groups = {};
        matches.forEach(function(item) {
          var group = item.product || 'Common Questions';
          if (!groups[group]) groups[group] = [];
          groups[group].push(item);
        });
        var groupNames = Object.keys(groups);
        var output = [];
        var index = 0;
        while (output.length < 8 && groupNames.length) {
          var added = false;
          groupNames.forEach(function(group) {
            if (groups[group][index]) {
              output.push(groups[group][index]);
              added = true;
            }
          });
          if (!added) break;
          index += 1;
        }
        return output;
      }
      function closeResults() {
        results.innerHTML = '';
        results.hidden = true;
      }
      function renderResults() {
        var rawQuery = input.value.trim();
        closeResults();
        if (!rawQuery) return;
        var query = normalize(rawQuery);
        var tokens = query.split(' ').filter(Boolean);
        var allItems = currentPageItems().concat(indexedItems()).concat(productFaqCatalog);
        var seen = {};
        var matches = allItems.map(function(item) {
          item._score = score(item, query, tokens);
          return item;
        }).filter(function(item) {
          var key = item.product + '|' + item.question;
          if (!item._score || seen[key]) return false;
          seen[key] = true;
          return true;
        }).sort(function(a, b) { return b._score - a._score; });
        matches = balanced(matches);
        if (!matches.length) {
          results.innerHTML = '<div class="xpai-help__search-empty">No matching questions found</div>';
          results.hidden = false;
          return;
        }
        matches.forEach(function(item) {
          var option = document.createElement('button');
          option.type = 'button';
          option.className = 'xpai-help__search-option';
          option.setAttribute('role', 'option');
          if (item.product) {
            var label = document.createElement('strong');
            label.textContent = item.product;
            var text = document.createElement('span');
            text.textContent = item.question;
            option.appendChild(label);
            option.appendChild(text);
          } else {
            option.textContent = item.question;
          }
          option.addEventListener('click', function() {
            closeResults();
            window.location.href = (item.url || window.location.pathname) + (item.target ? '#' + encodeURIComponent(item.target) : '');
          });
          results.appendChild(option);
        });
        results.hidden = false;
      }
      input.addEventListener('input', renderResults);
      input.addEventListener('focus', renderResults);
      input.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          var first = results.querySelector('.xpai-help__search-option');
          if (first) first.click();
          else renderResults();
        }
        if (event.key === 'Escape') closeResults();
      });
      button.addEventListener('click', function() {
        var first = results.querySelector('.xpai-help__search-option');
        if (first) first.click();
        else renderResults();
      });
      document.addEventListener('click', function(event) {
        if (!search.contains(event.target)) closeResults();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFaqSearch);
  else initFaqSearch();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-products-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xpai-products-hero'))customElements.define('xpai-products-hero',class extends HTMLElement{
connectedCallback(){this.querySelector('[data-products-anchor]')?.addEventListener('click',event=>{const target=document.querySelector('main .xpai-listing-products');if(!target)return;event.preventDefault();target.style.scrollMarginTop='100px';target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});target.setAttribute('tabindex','-1');target.focus({preventScroll:true});});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-products-newsletter"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xpai-products-newsletter'))customElements.define('xpai-products-newsletter',class extends HTMLElement{
connectedCallback(){
const form=this.querySelector('form'),input=this.querySelector('input[type=email]'),button=this.querySelector('button'),error=this.querySelector('[role=alert]'),status=this.querySelector('[data-loading-status]');if(!input)return;let busy=false,timer;
const reset=()=>{busy=false;clearTimeout(timer);button.removeAttribute('aria-disabled');form.removeAttribute('aria-busy');status.textContent='';};
input.addEventListener('invalid',()=>{input.setCustomValidity(this.dataset.invalid);error.textContent=this.dataset.invalid;error.hidden=false;});
input.addEventListener('input',()=>{input.setCustomValidity('');error.hidden=true;});
form.addEventListener('submit',event=>{if(busy){event.preventDefault();return;}if(!navigator.onLine){event.preventDefault();error.textContent='You appear to be offline. Please reconnect and try again.';error.hidden=false;return;}if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}busy=true;button.setAttribute('aria-disabled','true');form.setAttribute('aria-busy','true');status.textContent=this.dataset.loading;timer=setTimeout(reset,20000);});
this.resetSubmission=reset;window.addEventListener('pageshow',reset);
}
disconnectedCallback(){if(this.resetSubmission){this.resetSubmission();window.removeEventListener('pageshow',this.resetSubmission);}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-story-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xpai-story-film')){
customElements.define('xpai-story-film',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;
const toggle=this.querySelector('.xpai-story-film__toggle'),panel=this.querySelector('.xpai-story-film__panel');
toggle.addEventListener('click',()=>{
const open=toggle.getAttribute('aria-expanded')!=='true';
toggle.setAttribute('aria-expanded',String(open));panel.inert=!open;panel.setAttribute('aria-hidden',String(!open));
});
const video=this.querySelector('video'),play=this.querySelector('.xpai-story-film__play'),media=this.querySelector('.xpai-story-film__media');
if(video&&play){
play.addEventListener('click',()=>{const p=video.play();if(p)p.catch(()=>{media.classList.add('is-playing');video.focus({preventScroll:true});});});
video.addEventListener('play',()=>media.classList.add('is-playing'));
}
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-tiktok-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xpai-tiktok-gallery')) {
    customElements.define('xpai-tiktok-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.xtg__track');
        const cards = [...this.querySelectorAll('.xtg__card')];
        const dots = [...this.querySelectorAll('.xtg__dot')];
        const shown = () => cards.filter(card => !card.hidden);
        const go = index => {
          const card = cards[index];
          if (!card) return;
          track.scrollTo({left: card.offsetLeft - shown()[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), {signal}));
        const update = () => {
          let index = 0;
          let closest = Infinity;
          cards.forEach((card, i) => {
            if (card.hidden) return;
            const distance = Math.abs(card.offsetLeft - shown()[0].offsetLeft - track.scrollLeft);
            if (distance < closest) {closest = distance; index = i;}
          });
          dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        };
        track.addEventListener('scroll', update, {passive:true, signal});
        this.addEventListener('shopify:block:select', event => go(cards.indexOf(event.target.closest('.xtg__card'))), {signal});
        const refresh = () => {
          this.hidden = shown().length === 0;
          dots.forEach((dot, index) => {dot.hidden = cards[index].hidden;});
          const navigation = this.querySelector('.xtg__navigation');
          if (navigation) navigation.hidden = shown().length < 2;
          update();
        };
        const canonical = raw => {
          const url = new URL(raw);
          if (url.protocol !== 'https:' || url.username || url.password || url.port) throw new Error('请填写 HTTPS TikTok 视频链接。');
          if (!['www.tiktok.com','tiktok.com','vm.tiktok.com','vt.tiktok.com'].includes(url.hostname)) throw new Error('请填写 TikTok 视频链接。');
          if (/^\/@[^/]+\/video\/\d+\/?$/.test(url.pathname)) return 'https://www.tiktok.com' + url.pathname.replace(/\/$/,'');
          if (['vm.tiktok.com','vt.tiktok.com'].includes(url.hostname) || url.pathname.startsWith('/t/')) return url.origin + url.pathname;
          throw new Error('这是主页或无效链接，请复制含 /video/数字 的具体视频链接。');
        };
        const metadata = async (url, force = false) => {
          const key = 'xpai-tiktok-v2:' + url;
          if (!force) {
            try {const cached = JSON.parse(localStorage.getItem(key)); if (cached?.expires > Date.now() && cached.thumbnail) return cached;} catch {}
          }
          const response = await fetch('https://www.tiktok.com/oembed?url=' + encodeURIComponent(url), {credentials:'omit', signal:AbortSignal.any([signal,AbortSignal.timeout(10000)])});
          if (!response.ok) throw new Error('TikTok 暂时无法提供封面，请检查视频是否公开，或手动上传封面。');
          const data = await response.json();
          const thumbnail = new URL(data.thumbnail_url);
          if (thumbnail.protocol !== 'https:') throw new Error('未获取到有效封面，请手动上传。');
          const result = {thumbnail:thumbnail.href, expires:Date.now() + 30 * 60 * 1000};
          try {localStorage.setItem(key, JSON.stringify(result));} catch {}
          return result;
        };
        const loadImage = src => new Promise((resolve, reject) => {
          const image = new Image();
          const timer = setTimeout(() => {image.onload = null; image.onerror = null; reject(new Error('封面加载超时，请手动上传封面。'));},10000);
          image.onload = () => {clearTimeout(timer); resolve(src);};
          image.onerror = () => {clearTimeout(timer); reject(new Error('封面加载失败，请手动上传封面。'));};
          image.src = src;
        });
        cards.forEach(async card => {
          if (card.dataset.auto !== 'true') return;
          const editor = card.dataset.editor === 'true';
          const status = card.querySelector('.xtg__status');
          card.dataset.state = 'loading';
          if (!editor) card.hidden = true;
          try {
            const url = canonical(card.getAttribute('href'));
            let data = await metadata(url);
            try {await loadImage(data.thumbnail);} catch {data = await metadata(url,true); await loadImage(data.thumbnail);}
            if (signal.aborted) return;
            card.querySelector('.xtg__auto-image').src = data.thumbnail;
            card.hidden = false;
            card.dataset.state = 'ready';
            if (status) status.textContent = '已自动获取 TikTok 封面';
          } catch (error) {
            if (signal.aborted) return;
            card.dataset.state = 'error';
            if (status) status.textContent = error instanceof TypeError ? '无法读取 TikTok，请检查链接或网络，也可手动上传封面。' : error.message;
            if (!editor) card.hidden = true;
          }
          refresh();
        });
        refresh();
        update();
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xpai-video-shopping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('xpai-video-shopping')) {
    customElements.define('xpai-video-shopping', class extends HTMLElement {
      connectedCallback() {
        if(this.initialized)return;
        this.initialized=true;
        this.abort=new AbortController();
        this.dialog=this.querySelector('dialog');
        this.main=this.querySelector('.xvs-main-video');
        this.preview=this.querySelector('.xvs-preview-video');
        this.mini=this.querySelector('.xvs-mini');
        this.list=this.querySelector('.xvs-list');
        this.detail=this.querySelector('.xvs-detail');
        this.back=this.querySelector('[data-xvs-back]');
        this.entries=Array.from(this.querySelectorAll('[data-xvs-entry]'));
        this.mobile=window.matchMedia('(max-width:749px)');
        this.reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
        this.active=this.entries.find(entry=>entry.dataset.video)||this.entries[0];
        this.positions=new Map();
        this.setPreview();
        this.addEventListener('click',event=>this.handleClick(event),{signal:this.abort.signal});
        this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal:this.abort.signal});
        this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.close();}},{signal:this.abort.signal});
        document.addEventListener('visibilitychange',()=>{if(document.hidden){this.wasPlaying=!this.main.paused;this.main.pause();this.preview.pause();}else if(this.dialog.open&&this.wasPlaying){this.main.play().catch(()=>{});}else this.playPreview();},{signal:this.abort.signal});
        document.addEventListener('shopify:block:select',event=>{const entry=this.entries.find(item=>item.dataset.xvsEntry===event.detail.blockId);if(entry){this.open();this.selectVideo(entry);this.showDetail(entry);}},{signal:this.abort.signal});
        this.mobile.addEventListener('change',()=>{this.back.hidden=this.detail.hidden&&!this.mobile.matches;},{signal:this.abort.signal});
      }
      setPreview(){
        if(!this.active)return;
        this.preview.poster=this.active.dataset.poster||'';
        if(this.active.dataset.video&&this.dataset.enabled==='true'){
          this.preview.src=this.active.dataset.video;
          this.preview.muted=true;
          this.playPreview();
        }
      }
      playPreview(){if(this.dataset.autoplay==='true'&&!this.reduced.matches&&!navigator.connection?.saveData&&!document.hidden&&!this.dialog.open&&!this.mini.hidden&&this.preview.getAttribute('src'))this.preview.play().catch(()=>{});}
      handleClick(event){
        const button=event.target.closest('button');if(!button)return;
        if(button.hasAttribute('data-xvs-open')){this.returnFocus=button;this.open();}
        else if(button.hasAttribute('data-xvs-close'))this.close();
        else if(button.hasAttribute('data-xvs-dismiss')){this.mini.hidden=true;this.preview.pause();}
        else if(button.hasAttribute('data-xvs-detail')){const entry=this.entries.find(item=>item.dataset.xvsEntry===button.dataset.xvsDetail);this.selectVideo(entry);this.showDetail(entry);}
        else if(button.hasAttribute('data-xvs-watch')){this.selectVideo(this.entries.find(item=>item.dataset.xvsEntry===button.dataset.xvsWatch));this.showList();this.dialog.removeAttribute('data-shopping');}
        else if(button.hasAttribute('data-xvs-current'))this.showDetail(this.active);
        else if(button.hasAttribute('data-xvs-shop')){this.showList();this.dialog.setAttribute('data-shopping','');this.back.focus({preventScroll:true});}
        else if(button.hasAttribute('data-xvs-back')){if(!this.detail.hidden)this.showList();else{this.dialog.removeAttribute('data-shopping');this.querySelector('[data-xvs-shop]').focus({preventScroll:true});}}
        else if(button.hasAttribute('data-xvs-prev'))this.gallery(-1);
        else if(button.hasAttribute('data-xvs-next'))this.gallery(1);
      }
      open(){
        if(this.dialog.open)return;
        this.preview.pause();
        this.savedOverflow=document.documentElement.style.overflow;
        document.documentElement.style.overflow='hidden';
        this.locked=true;
        this.showList();this.dialog.removeAttribute('data-shopping');
        this.dialog.showModal();
        this.selectVideo(this.active,true);
      }
      selectVideo(entry,resume=false){
        if(!entry)return;
        const changed=this.loadedEntry!==entry;
        this.active=entry;
        if(changed){
          if(this.loadedEntry)this.positions.set(this.loadedEntry.dataset.xvsEntry,this.main.currentTime);
          this.main.pause();
          this.loadedEntry=entry;
          this.main.poster=entry.dataset.poster||'';
          if(entry.dataset.video){this.main.src=entry.dataset.video;const saved=this.positions.get(entry.dataset.xvsEntry)||0;this.main.addEventListener('loadedmetadata',()=>{if(this.loadedEntry===entry&&saved<this.main.duration)this.main.currentTime=saved;},{once:true,signal:this.abort.signal});}
          else{this.main.removeAttribute('src');this.main.load();}
        }
        this.querySelector('.xvs-video-title').textContent=entry.dataset.title;
        this.querySelector('.xvs-empty-video').hidden=Boolean(entry.dataset.video);
        const card=this.querySelector('.xvs-overlay-card');card.replaceChildren();
        const sourceCard=entry.querySelector('.xvs-list-card');
        Array.from(sourceCard.children).forEach(child=>card.append(child.cloneNode(true)));
        card.hidden=entry.dataset.product!=='true';
        this.entries.forEach(item=>item.toggleAttribute('data-active',item===entry));
        if(entry.dataset.video&&(changed||resume)){this.main.muted=false;this.main.play().catch(()=>{});}
      }
      showDetail(entry){
        if(!entry)return;
        this.detail.replaceChildren(entry.querySelector('template').content.cloneNode(true));
        this.detail.hidden=false;this.list.hidden=true;this.back.hidden=false;
        this.dialog.setAttribute('data-shopping','');this.galleryIndex=0;this.gallery(0);
        this.back.focus({preventScroll:true});
      }
      showList(){this.detail.hidden=true;this.list.hidden=false;this.back.hidden=!this.mobile.matches;}
      gallery(step){const slides=Array.from(this.detail.querySelectorAll('.xvs-slide'));if(!slides.length)return;this.galleryIndex=(this.galleryIndex+step+slides.length)%slides.length;slides.forEach((slide,index)=>slide.hidden=index!==this.galleryIndex);const counter=this.detail.querySelector('[data-xvs-counter]');if(counter)counter.textContent=`${this.galleryIndex+1} / ${slides.length}`;}
      close(){
        this.main.pause();this.preview.pause();
        if(this.dialog.open)this.dialog.close();
        if(this.locked){document.documentElement.style.overflow=this.savedOverflow;this.locked=false;}
        if(this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});
      }
      disconnectedCallback(){this.close();this.abort?.abort();this.initialized=false;}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y3e-preorder-v2"] && !Shopify.designMode) return;
  try {
    
function initY3EHero(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const rail=root.querySelector('.y3e-shop__rail'),slides=[...root.querySelectorAll('.y3e-shop__slide')],thumbs=[...root.querySelectorAll('[data-gallery-index]')];
 function go(i){if(!slides.length)return;i=(i+slides.length)%slides.length;rail.scrollTo({left:i*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
 root.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>go(Math.round(rail.scrollLeft/rail.clientWidth)+Number(b.dataset.galleryStep))));
 thumbs.forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.galleryIndex))));
 rail.addEventListener('scroll',()=>{const i=Math.round(rail.scrollLeft/rail.clientWidth);thumbs.forEach((b,j)=>b.setAttribute('aria-pressed',String(i===j)));},{passive:true});
 root.querySelector('[data-show-rules]').addEventListener('click',()=>{const d=root.querySelector('details');d.open=true;d.querySelector('summary').focus();});
}
document.querySelectorAll('.y3e-shop').forEach(initY3EHero);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.y3e-shop').forEach(initY3EHero));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y3e-story-v2"] && !Shopify.designMode) return;
  try {
    
function initY3EStory(root){if(root.dataset.ready)return;root.dataset.ready='true';const range=root.querySelector('input[type=range]');if(range)range.addEventListener('input',()=>root.querySelector('.y3e-story__compare').style.setProperty('--position',range.value+'%'));}
document.querySelectorAll('.y3e-story').forEach(initY3EStory);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.y3e-story').forEach(initY3EStory));

  } catch(e) { console.error(e); }
})();
})();
